module.exports = __webpack_public_path__ + "media/images/affiliation_logos/affiliate_logo_umiami-a9230479568e907154ddffc5742c24c7.png";